import { render, staticRenderFns } from "./logout-view.vue?vue&type=template&id=a922ef54"
import script from "./logout-view.vue?vue&type=script&lang=js"
export * from "./logout-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports